import { defineStore } from 'pinia';
import { axiosRequest } from '@core/composables/helpers/axios-requests';
import { useStorage } from "vue3-storage";
import { ref } from 'vue';
import router from '@/router';
import { useUserStore } from './user.store';
import { useI18n } from "vue-i18n";
import track from '@core/composables/useGTM'

const storage = useStorage();
const qryParams = ref('');


export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        token: storage.getStorageSync("customerJWT"),
        err: null,
        i18: useI18n(),
    }),
    actions: {
        async signup(payLoad){
            const token = await axiosRequest.post('/customers', payLoad);
            const {t} = this.i18;
            if(!token){
                this.err = t("auth.error");
            }
            else {
                if(![409, 400, 403].includes(token.status)) {
                    storage.setStorageSync("customerJWT", token.data.token);
                    this.token = token.data.token;
                    storage.setStorageSync("select-readers", 'select-readers');
                    await this.useLogin('SelectReaders');
                    if(router.currentRoute.value.path === '/select-readers'){
                        // GTM sign_up event
                        track.signUp();
                    }
                    
                }
                else {
                    if([409].includes(token.status)){
                        this.err = t("auth.errorUser");
                    }
                    else {
                        this.err = t("auth.errorInvalid");
                    }
                }
            }
        },
        async login(payLoad){
            const token = await axiosRequest.post('/customers/login', payLoad);
            const {t} = this.i18;
            if(!token){
                this.err = t("auth.error");
            }
            else {
                if(![409, 400, 403].includes(token.status)) {
                    storage.setStorageSync("customerJWT", token.data.token);
                    this.token = token.data.token;
                    this.useLogin('Readers');
                }
                else {
                    this.err = t("auth.incorrect");
                }
            }
        },
        async useLogin(path){
            if(sessionStorage.getItem('fbclid') && !sessionStorage.getItem('lead')) {
                qryParams.value = { 'fbclid': sessionStorage.getItem('fbclid') };
            }
            if(this.token){
                router.push({ name: path, query: qryParams.value });
                const userStore = useUserStore();
                await userStore.getUser(this.token);
            }
        },
        logout(){
            this.token = null;
            storage.clearStorageSync();
            router.push({name: 'Login'});
        },
        clearErrMsg(){
            this.err = null;
        }
    },
    getters: {
        errMsg: state => state.err,
        isAuthenticated: state => !!state.token
    },
});
